import * as ibantools from 'ibantools';

export const isPortugueseIban = (iban: string) => {
  return ibantools.isValidIBAN(iban) && iban.startsWith('PT');
};

export const isValidIban = (iban: string) => {
  return ibantools.isValidIBAN(iban);
};
